import { makeAutoObservable } from "mobx"
import { API } from "./API"
import { CognitoUserPool, CognitoUser, AuthenticationDetails } from "amazon-cognito-identity-js"

const userPool = new CognitoUserPool({
	UserPoolId: "us-east-1_v9YGJ8IxY",
	ClientId: "1igli8lll7otfje3bivkk843ch",
})

class AuthStore {
	loading = false
	error = undefined
	authenticated = false
	cognetoID = null
	accessToken = null

	constructor() {
		makeAutoObservable(this)

		let sessionToken = sessionStorage.getItem("accessToken")
		if (sessionToken) {
			this.authenticated = true
		}
	}

	authenticate(email, password, newPassword = null, kickOnFail = false) {
		this.loading = true
		this.error = undefined
		const user = new CognitoUser({ Username: email, Pool: userPool })

		const authenticationData = {
			Username: email,
			Password: password,
		}
		const authenticationDetails = new AuthenticationDetails(authenticationData)
		return new Promise((resolve, reject) => {
			user.authenticateUser(authenticationDetails, {
				onSuccess: (result) => {
					console.log(result.idToken.payload)
					this.accessToken = result.accessToken.jwtToken
					this.cognetoID = result.idToken.payload
					this.authenticated = true
					this.loading = false
					sessionStorage.setItem("accessToken", this.accessToken)
					API.setAccessToken(this.accessToken)
					resolve(true)
				},
				onFailure: (err) => {
					console.log(err)
					this.loading = false
					if (kickOnFail) this.authenticated = false
					if (err.name === "NotAuthorizedException") reject(err)
				},
				newPasswordRequired: function (userAttributes) {
					if (!newPassword) reject({ code: "newPasswordRequired" })
					else {
						delete userAttributes.email_verified
						delete userAttributes.email
						user.completeNewPasswordChallenge(newPassword, userAttributes, {
							onSuccess: (result) => resolve(true),
							onFailure: (err) => {
								console.log(err)
								reject(false)
							},
						})
					}
				},
			})
		})
	}

	forgotPassword(email) {
		const user = new CognitoUser({ Username: email, Pool: userPool })
		user.forgotPassword()
	}

	confirmPassword(email, newPassword, verificationCode) {
		const user = new CognitoUser({ Username: email, Pool: userPool })
		return new Promise((resolve, reject) => {
			user.confirmPassword(verificationCode, newPassword, {
				onFailure(err) {
					reject(err)
				},
				onSuccess() {
					resolve()
				},
			})
		})
	}

	logout() {
		this.authenticated = false
		this.cognetoID = null
		this.accessToken = null
	}
}

export const authStore = new AuthStore()
